import _keyBy from 'lodash/keyBy';
import { UserStatus, UserType } from 'api/models';
import { TimeOffType } from 'api/timeoff/types';
import { db } from '../workers/db';
import { Team as TeamModel } from '../workers/models';
export async function saveMemberData(members) {
    // clear existing members data before inserting
    await db.members.clear();
    return db.members.bulkPut(members);
}
export async function saveTeamData(teams) {
    // clear existing team data before inserting
    await db.teams.clear();
    return db.teams.bulkPut(teams);
}
export async function addMember(member) {
    const user = await db.members.get(member.userId);
    // activating an deactivated user will also trigger the addMember handler
    // in that case just update the user data to not loose the existing projectIds prop
    // Note: projectIds prop is not sent in user object which comes via web socket
    if (user) {
        return db.members.update(member.userId, {
            ...user,
            ...member
        });
    }
    return db.members.put({
        ...member,
        projectIds: []
    });
}
export async function updateMember(member) {
    const user = await db.members.get(member.userId);
    if (user) {
        return db.members.update(member.userId, {
            ...user,
            ...member
        });
    }
    return Promise.reject(new Error(`No user found for id ${member === null || member === void 0 ? void 0 : member.userId}`));
}
export async function deleteMember(userId) {
    return db.members.delete(userId);
}
export async function addTeam(team) {
    const teamdata = new TeamModel(team);
    return db.teams.put(teamdata);
}
export async function updateMemberStatus(userId, userStatus) {
    return db.members.update(userId, {
        userStatus
    });
}
export async function updateTeam(team) {
    try {
        const teamData = await db.teams.get(team.teamId);
        await db.teams.update(team.teamId, {
            ...team,
            projectIds: teamData === null || teamData === void 0 ? void 0 : teamData.projectIds,
            accountLevelTeam: teamData === null || teamData === void 0 ? void 0 : teamData.accountLevelTeam
        });
    } catch (error) {
        throw new Error(`Error occured while updatimg team. teamId: ${team === null || team === void 0 ? void 0 : team.teamId}: ${error}`, {
            cause: error
        });
    }
}
export async function deleteTeam(teamId) {
    return db.teams.delete(teamId);
}
export async function getTeam(teamId) {
    return db.teams.get(teamId);
}
export async function addProjectToTeam({ teamId, projectId }) {
    try {
        var _team_projectIds;
        const team = await db.teams.get(teamId);
        if (team && !(team === null || team === void 0 ? void 0 : (_team_projectIds = team.projectIds) === null || _team_projectIds === void 0 ? void 0 : _team_projectIds.includes(projectId))) {
            var _team_projectIds1;
            team === null || team === void 0 ? void 0 : (_team_projectIds1 = team.projectIds) === null || _team_projectIds1 === void 0 ? void 0 : _team_projectIds1.push(projectId);
            await db.teams.update(teamId, team);
        }
    } catch (error) {
        throw new Error(`Error occured while adding projectId to team. teamId: ${teamId} projectId: ${projectId}: Cause: ${error}`, {
            cause: error
        });
    }
}
export async function addProjectToTeams({ teamIds, projectId }) {
    teamIds.forEach(async (teamId)=>{
        try {
            var _team_projectIds;
            const team = await db.teams.get(teamId);
            if (team && !(team === null || team === void 0 ? void 0 : (_team_projectIds = team.projectIds) === null || _team_projectIds === void 0 ? void 0 : _team_projectIds.includes(projectId))) {
                var _team_projectIds1;
                team === null || team === void 0 ? void 0 : (_team_projectIds1 = team.projectIds) === null || _team_projectIds1 === void 0 ? void 0 : _team_projectIds1.push(projectId);
                await db.teams.update(teamId, team);
            }
        } catch (error) {
            throw new Error(`Error occured while adding projectId to team. teamId: ${teamId} projectId: ${projectId}: Cause: ${error}`, {
                cause: error
            });
        }
    });
}
export async function removeProjectFromTeam({ teamId, projectId }) {
    try {
        var _team_projectIds;
        const team = await db.teams.get(teamId);
        if (team && (team === null || team === void 0 ? void 0 : (_team_projectIds = team.projectIds) === null || _team_projectIds === void 0 ? void 0 : _team_projectIds.includes(projectId))) {
            var _team_projectIds1;
            team.projectIds = team === null || team === void 0 ? void 0 : (_team_projectIds1 = team.projectIds) === null || _team_projectIds1 === void 0 ? void 0 : _team_projectIds1.filter((p)=>p !== projectId);
            await db.teams.update(teamId, team);
        }
    } catch (error) {
        throw new Error(`Error occured while removing projectId from team. teamId: ${teamId} projectId: ${projectId}: Cause: ${error}`, {
            cause: error
        });
    }
}
export async function removeUserFromProject(userId, projectId) {
    var _user_projectIds;
    const user = await db.members.get(userId);
    const projectIds = user === null || user === void 0 ? void 0 : (_user_projectIds = user.projectIds) === null || _user_projectIds === void 0 ? void 0 : _user_projectIds.filter((p)=>p !== projectId);
    const res = await db.members.update(userId, {
        projectIds
    });
    return res;
}
export async function addUserToProject(userId, projectId) {
    const user = await db.members.get(userId);
    const projectIds = user === null || user === void 0 ? void 0 : user.projectIds;
    if (user) {
        if (!(projectIds === null || projectIds === void 0 ? void 0 : projectIds.includes(projectId))) {
            projectIds === null || projectIds === void 0 ? void 0 : projectIds.push(projectId);
        }
        await db.members.update(userId, {
            projectIds
        });
    }
    return undefined;
}
export async function addUsersAndTeamsToNewProject({ projectId, userIds, teams }) {
    try {
        // check if project already added to users
        const projectExists = await db.members.where('projectIds').equals(projectId).toArray();
        // if atleast one user already exist in the project return and save the below computation
        if (projectExists === null || projectExists === void 0 ? void 0 : projectExists.length) {
            return false;
        }
        const users = await db.members.where('userId').anyOf(userIds).toArray();
        if (users === null || users === void 0 ? void 0 : users.length) {
            users.forEach((user)=>{
                var _user_projectIds;
                if (!((_user_projectIds = user.projectIds) === null || _user_projectIds === void 0 ? void 0 : _user_projectIds.includes(projectId))) {
                    var _user_projectIds1;
                    (_user_projectIds1 = user.projectIds) === null || _user_projectIds1 === void 0 ? void 0 : _user_projectIds1.push(projectId);
                }
            });
            const teamList = teams.map((team)=>({
                    ...team,
                    projectIds: [
                        projectId
                    ]
                }));
            await Promise.all([
                db.teams.bulkPut(teamList),
                db.members.bulkPut(users)
            ]);
            return true;
        }
    } catch (error) {
        throw new Error(`Error occured while updating newly created projectId:${projectId} in users and teams. Cause: ${error}`, {
            cause: error
        });
    }
    return false;
}
export async function addUserTimeoff({ userId, timeoffData }) {
    try {
        const user = await db.members.get(userId);
        const timeOff = (user === null || user === void 0 ? void 0 : user.userTimeOffDetails) ? [
            ...user.userTimeOffDetails || []
        ] : [];
        timeOff.push({
            note: (timeoffData === null || timeoffData === void 0 ? void 0 : timeoffData.note) || '',
            timeOffEnd: (timeoffData === null || timeoffData === void 0 ? void 0 : timeoffData.timeOffEnd) || '',
            timeOffId: timeoffData === null || timeoffData === void 0 ? void 0 : timeoffData.timeOffId,
            timeOffStart: (timeoffData === null || timeoffData === void 0 ? void 0 : timeoffData.timeOffStart) || '',
            timeOffDuration: timeoffData === null || timeoffData === void 0 ? void 0 : timeoffData.timeOffDuration,
            timeOffType: (timeoffData === null || timeoffData === void 0 ? void 0 : timeoffData.timeOffType) || TimeOffType.FullDay,
            appliedBy: timeoffData === null || timeoffData === void 0 ? void 0 : timeoffData.appliedBy
        });
        if (user) {
            await db.members.update(userId, {
                userTimeOffDetails: timeOff
            });
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
    return undefined;
}
export async function deleteUserTimeoff({ userId, timeoffId }) {
    try {
        var _user_userTimeOffDetails;
        const user = await db.members.get(userId);
        const filtertedTimeoffData = user === null || user === void 0 ? void 0 : (_user_userTimeOffDetails = user.userTimeOffDetails) === null || _user_userTimeOffDetails === void 0 ? void 0 : _user_userTimeOffDetails.filter((t)=>t.timeOffId !== timeoffId);
        if (user) {
            await db.members.update(userId, {
                userTimeOffDetails: filtertedTimeoffData
            });
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
    return undefined;
}
export async function getUsersInProject(projectId) {
    return db.members.where('projectIds').equals(projectId).filter((user)=>user.userStatus !== UserStatus.Inactive).toArray();
}
export async function getUsersInProjects(projectIds) {
    return db.members.where('projectIds').anyOf(projectIds).filter((user)=>user.userStatus !== UserStatus.Inactive).toArray();
}
export async function getUsersNotInProject(projectId) {
    const usersNotinProject = await db.members.filter((user)=>{
        var _user_projectIds;
        return !((_user_projectIds = user.projectIds) === null || _user_projectIds === void 0 ? void 0 : _user_projectIds.includes(projectId)) && user.userStatus !== UserStatus.Inactive;
    }).toArray();
    return usersNotinProject;
}
export async function getActiveUsers() {
    const activeUsers = await db.members.filter((user)=>user.userStatus !== UserStatus.Inactive).toArray();
    return activeUsers;
}
export async function getAllActiveUsersAndTeams() {
    const activeUsers = await getActiveUsers();
    const teams = await db.teams.toArray();
    return {
        activeUsers,
        teams
    };
}
export async function getAllNativeUsers() {
    const activeUsers = await db.members.where({
        userType: UserType.Native
    }).filter((user)=>user.userStatus !== UserStatus.Inactive).toArray();
    return activeUsers;
}
export async function getUserById(userId) {
    if (!userId) {
        return {};
    }
    const user = await db.members.where({
        userId
    }).first();
    return user || {};
}
export async function getUsersByIds(userIds) {
    if (!userIds.length) {
        return [];
    }
    const users = await db.members.where('userId').anyOf(userIds).toArray();
    return _keyBy(users, 'userId');
}
export async function getAllUsers() {
    const users = await db.members.toArray();
    return _keyBy(users, 'userId');
}
export async function updateUserHolidayCalendar({ userId, holidayCalendarId }) {
    try {
        const user = await db.members.get(userId);
        if (user) {
            await db.members.update(userId, {
                ...user,
                holidayCalendarId
            });
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
    return undefined;
}
export async function addUserHolidayCalendar({ emails, holidayCalendarId }) {
    try {
        const users = await db.members.where('emailId').anyOf(emails).toArray();
        if (users) {
            users.forEach(async (user)=>{
                await db.members.update(user.userId, {
                    ...user,
                    holidayCalendarId
                });
            });
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
    return undefined;
}
